(function promoQuickshop(){
  let modal = document.getElementById('promoQuickshopModal');
  if (!modal) return;
  let titleEl = modal.querySelector('.promo-quickshop-title');
  let sizesWrap = modal.querySelector('.promo-quickshop-sizes');
  let sizesList = modal.querySelector('.promo-quickshop-sizes-list');
  let addBtn = modal.querySelector('.promo-quickshop-add');
  let viewFullLink = modal.querySelector('.promo-quickshop-view-full');
  let errorEl = modal.querySelector('.promo-quickshop-error');
  let selectedVariantId = null;
  let isAdding = false;

  function closeModal(){
    document.body.classList.remove('open-promo-quickshop');
  }
  function openModal(){
    document.body.classList.add('open-promo-quickshop');
  }
  function setError(message){
    errorEl.textContent = message || '';
  }
  function selectVariant(variantId, button){
    selectedVariantId = variantId;
    sizesList.querySelectorAll('button').forEach(function(btn){
      btn.classList.toggle('promo-size-selected', btn === button);
    });
    addBtn.disabled = !variantId;
  }
  function populateModal(trigger){
    let dataScript = trigger.querySelector('.quickshop-data');
    let data = {};
    try {
      data = JSON.parse(dataScript.textContent);
    } catch(e){
      data = { sizes: [], defaultVariantId: null };
    }
    let sizes = data.sizes || [];

    titleEl.textContent = trigger.getAttribute('data-product-title') || '';
    viewFullLink.setAttribute('href', trigger.getAttribute('data-product-url') || '#');
    setError('');
    sizesList.innerHTML = '';
    selectedVariantId = null;
    addBtn.disabled = true;

    if (!sizes.length) {
      sizesWrap.style.display = 'none';
      if (data.defaultVariantId) selectVariant(data.defaultVariantId, null);
      return;
    }

    sizesWrap.style.display = '';
    sizes.forEach(function(size){
      let btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = size.label;
      if (!size.available) {
        btn.classList.add('promo-size-unavailable');
      } else {
        btn.addEventListener('click', function(){
          selectVariant(size.id, btn);
        });
      }
      sizesList.appendChild(btn);
    });
  }

  document.addEventListener('click', function(e){
    let trigger = e.target.closest('.quickshop-trigger');
    if (trigger) {
      populateModal(trigger);
      openModal();
      return;
    }
    if (e.target === modal || e.target.closest('.promo-quickshop-close')) {
      closeModal();
      return;
    }
    if (e.target.closest('.promo-quickshop-add')) {
      if (isAdding || !selectedVariantId) return;
      isAdding = true;
      setError('');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] })
      })
        .then(function(response){ return response.json(); })
        .then(function(data){
          if (data.status === 422) {
            setError(data.description || 'Unable to add this item to your cart.');
            return;
          }
          closeModal();
          if (typeof load_cart === 'function') {
            load_cart();
            document.body.classList.add('open-drawer');
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function(){
          setError('Unable to add this item to your cart.');
        })
        .finally(function(){
          isAdding = false;
        });
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && document.body.classList.contains('open-promo-quickshop')) {
      closeModal();
    }
  });
})();
